import { handleVersion } from './handlers/handle_version'
import { handleSetLed, handleSetLedDecoration } from './handlers/handle_set_led'
import { DriverSocketMsgType as typeMsg } from '@libs/types/message'
import { forgetDevice, getCurrentDevice, getDeviceList, handleDeviceUpdate, requestDevice, selectDevice } from './handlers/handle_device'
import { handleSetkey } from './handlers/handle_set_key'
import {
  handleCfgList,
  handleCfgSwitch,
  handleCfgCreate,
  handleCfgDelete,
  handleCfgRename,
  handleCfgImport,
  handleCfgImportReplace,
  handleCfgExport,
  handleCfgBindShortcut,
  handleOnboardCfgList,
  handleOnboardCfgSync,
  handleOnboardCfgRename,
  handleOnboardCfgMigrationCheck,
  handleOnboardCfgMigrationExecute,
  handleOnboardCfgReplaceSlot,
  handleReplicateSwitchKeys,
} from './handlers/handle_profile'
import { handleDefineKeys, handleGetKeyZones } from './handlers/handle_define'
import { handleSwitchDPI } from './handlers/handle_switch_dpi'
import { handleSetDPI } from './handlers/handle_set_dpi'
import { handleSetMacro } from './handlers/handle_set_macro'
import { handleDeviceState } from './handlers/handle_device_state'
import { handleReadSettings } from './handlers/handle_read_settings'
import { handleRecorder } from './handlers/handle_recorder'
import { handleSetReset } from './handlers/handle_set_reset'
import { handleCheckEnableDynamicColor, handleDynamicColor } from './handlers/handle_dynamic_color'
import { handleSetCustomColor } from './handlers/handle_set_custom_color'
import { handleCalibration, handleGetKeyInfo, handleGetKeysGroup, handleSetKeyInfo, handleSetKeysGroup, handleTravels, handleGetKeyDeadZone, handleSetKeyDeadZone } from './handlers/handle_magnet'
import { HandleSetMagnetSeniorkey } from './handlers/handle_set_magnet_senior_key'
import { handleSetOrReadSpecificItem } from './handlers/handle_set_or_read_specific_item'
import { handlePair24G } from './handlers/handle_pair_24g'
import { handlePollingRate } from './handlers/handle_polling_rate'
import { handleImageLightFrame } from './handlers/handle_image_light_frame'

// export interface ResHandle {
//     Data: any;
//     Error: string;
// }

export type fnHandler = (data: any) => Promise<any>

const mapRouter = new Map<typeMsg, fnHandler>([
  [typeMsg.MTDeviceVersion, handleVersion],
  [typeMsg.MTCurrentDevices, getDeviceList],
  [typeMsg.MTSelectDevice, selectDevice],
  [typeMsg.MSRequestDevice, requestDevice],
  // [typeMsg.MSWatchDevice, deviceConnectChange],
  [typeMsg.MTSetLed, handleSetLed],
  [typeMsg.MTSetKeysColor, handleSetCustomColor],
  [typeMsg.MTSetKey, handleSetkey],
  [typeMsg.MTSetMacro, handleSetMacro],
  [typeMsg.MTDeviceState, handleDeviceState],
  [typeMsg.MTUsingDevice, getCurrentDevice],
  [typeMsg.MTGetDefineKeys, handleDefineKeys],
  [typeMsg.MTPollingRate, handlePollingRate],
  [typeMsg.MTReadSettings, handleReadSettings],
  [typeMsg.MTCfgList, handleCfgList],
  [typeMsg.MTCfgChange, handleCfgSwitch],
  [typeMsg.MTCfgCreate, handleCfgCreate],
  [typeMsg.MTCfgDelete, handleCfgDelete],
  [typeMsg.MTCfgRename, handleCfgRename],
  [typeMsg.MTCfgImport, handleCfgImport],
  [typeMsg.MTCfgImportReplace, handleCfgImportReplace],
  [typeMsg.MTCfgExport, handleCfgExport],
  [typeMsg.MTSwitchDPI, handleSwitchDPI],
  [typeMsg.MTWatchKey, handleRecorder],
  [typeMsg.MTSetReset, handleSetReset],
  [typeMsg.MTMusicalRhythm, handleDynamicColor],
  [typeMsg.MTMusicalRhythmEnable, handleCheckEnableDynamicColor],
  [typeMsg.MTImageLightFrame, handleImageLightFrame],
  [typeMsg.MTSetDPIData, handleSetDPI],
  [typeMsg.MTForgetDevice, forgetDevice],

  [typeMsg.MTMagnetCalibratin, handleCalibration], // 开始结束校准
  [typeMsg.MTMagnetSingleCalibratin, async () => {}], // 单个按键校准

  [typeMsg.MTMagnetSetKeyInfo, handleSetKeyInfo],
  [typeMsg.MTMagnetGetKeyInfo, handleGetKeyInfo], // 获取行程值

  [typeMsg.MTMagnetSetKeyDeadZone, handleSetKeyDeadZone],
  [typeMsg.MTMagnetGetKeyDeadZone, handleGetKeyDeadZone],

  [typeMsg.MTMagnetSetWatch, handleTravels],

  [typeMsg.MSMagnetDynamicKey, async () => {}], // 行程
  [typeMsg.MSMagnetFluxKey, async () => {}], // 磁通量
  [typeMsg.MSMagnetWatchCalibratin, async () => {}], // 监听校准值

  [typeMsg.MTMagnetSeniorKey, HandleSetMagnetSeniorkey], // 高级改键
  [typeMsg.MTSetOrReadSpecificItem, handleSetOrReadSpecificItem],
  [typeMsg.MTGetKeyZones, handleGetKeyZones],

  [typeMsg.MTGetKeysGroup, handleGetKeysGroup],
  [typeMsg.MTSetKeysGroup, handleSetKeysGroup],
  [typeMsg.MTPair24G, handlePair24G],
  [typeMsg.MTDeviceUpdate, handleDeviceUpdate],

  [typeMsg.MTSetLightDecoration, handleSetLedDecoration],

  [typeMsg.MTCfgBindShortcut, handleCfgBindShortcut],
  [typeMsg.MTOnboardCfgList, handleOnboardCfgList],
  [typeMsg.MTOnboardCfgSync, handleOnboardCfgSync],
  [typeMsg.MTOnboardCfgRename, handleOnboardCfgRename],
  [typeMsg.MTOnboardCfgMigrationCheck, handleOnboardCfgMigrationCheck],
  [typeMsg.MTOnboardCfgMigrationExecute, handleOnboardCfgMigrationExecute],
  [typeMsg.MTOnboardCfgReplaceSlot, handleOnboardCfgReplaceSlot],
  [typeMsg.MTReplicateSwitchKeys, handleReplicateSwitchKeys],
])

export const getHandler = (t: typeMsg): fnHandler => {
  if (!mapRouter.has(t)) {
    throw new Error('No handler for this message type.')
  }
  return mapRouter.get(t) as fnHandler
}
